import React, { useEffect, useState } from 'react'
import '../styles/Init.styles.css'
import carousel1 from '../assets/carousel1.png'
import carousel2 from '../assets/carousel2.png'
import img1 from '../assets/imgCarousel1.jpg'
import img2 from '../assets/imgCarousel2.jpg'
import img3 from '../assets/imgCarousel3.jpg'
import img1p from '../assets/imgSlider1.jpg'
import img2p from '../assets/imgSlider2.jpg'
import img3p from '../assets/imgSlider3.jpg'

export default function Init() {
  const [imagenActual, setImagenActual] = useState(0);
  const imagenes = [carousel1,carousel2];
  useEffect(() => {
    const intervalo = setInterval(() => {
      setImagenActual(prevIndex => (prevIndex + 1) % imagenes.length);
    }, 6000);
    return () => clearInterval(intervalo);
  }, [imagenes.length]);

  return (
    <section className='init' id='inicio'>
      <div className="carrusel-contenedor">
        {imagenes.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Imagen ${index + 1}`}
            className={`carrusel-img ${index === imagenActual ? 'activa' : ''}`}
          />
        ))}
      </div>
      <div className='in-container'>
        <div className='in-infoContainer'>
          <div className={`containerTxt ${imagenActual === 0 ? 'containerTxt2': ''} `}>
            <div className={`divTxtI `}>
              {
                imagenActual === 1 ?
                <h2 className={`txtImg2`}>
                  PLANIFICAMOS<br/> 
                  DESARROLLAMOS<br/> 
                  CONSTRUIMOS
                </h2> :
                <h2 className={`txtImg1`}>
                  CALIDAD, DISEÑO<br/> 
                  Y EFICIENCIA <br/> 
                  EN CADA OBRA
                </h2>
              }   
            </div>
          </div>
          <div className='in-backTexto'>
            <div className={`divTxtImg2 ${imagenActual === 0 ? 'divTxtImg2left':''}`}>
              <div  className='imageCarousel'>
                {""}
              </div>
              <div className='imageCarousel1'>
                <img src={imagenActual === 0? img2p : img1} alt='img'/>
              </div>
              <div className='imageCarousel2'>
                <img src={imagenActual === 0? img1p : img2} alt='img'/>
              </div>
              <div className='imageCarousel3'>
                <img src={imagenActual === 0? img3p : img3}  alt='img'/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
